import PropTypes from "prop-types";
import React, { useState } from "react";
import Overlay from "web/react/components/overlay/overlay";
import ComparisonOption from "web/react/components/comparison-option/comparison-option";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { gettext } from "web/script/modules/django-i18n";
import { BuyOptionPropType } from "web/types/buy-option";
import analytics from "web/script/analytics/analytics";
import classnames from "classnames";
import style from "./product-description-compare-prices.css";

function ProductDescriptionComparePrice({
    allSizesSorted,
    analyticsTitle,
    buyOptions,
    shouldDisplaySizes,
    inlineVariant,
    sortedBuyOptions,
    title,
}) {
    const [comparePriceOpen, setComparePriceOpen] = useState(false);

    function openModal() {
        setComparePriceOpen(true);
        analytics.event(analyticsTitle ? analyticsTitle : "compare-prices", "clicked", "open");
    }

    function closeModal() {
        setComparePriceOpen(false);
    }

    const comparePriceText = gettext("in_stock_product.compare_prices_in_stores_link", {
        store_count: sortedBuyOptions.length,
    });

    const comparePriceTextTest = gettext("in_stock_product.compare_prices_text_link");

    return (
        <React.Fragment>
            <button
                className={classnames({
                    [style.comparePricesTest]: inlineVariant,
                    [style.comparePrices]: !inlineVariant,
                })}
                onClick={openModal}
                type="button"
            >
                <span className={style.comparePricesText}>
                    {title ? title : inlineVariant ? comparePriceTextTest : comparePriceText}
                </span>
                <SVGIcon className={style.icon} name="round-chevron" />
            </button>

            <Overlay
                isOpen={comparePriceOpen}
                title={gettext("in_stock_product.store_comparison_title")}
                onRequestClose={closeModal}
            >
                {sortedBuyOptions.map((linkId, index) => {
                    const buyOption = buyOptions[linkId];
                    const defaultSize = buyOption.sizes[buyOption.default_size];
                    let shippingOptions = null;
                    if (defaultSize.shipping_info) {
                        shippingOptions = defaultSize.shipping_info;
                    }
                    let freeReturn = false;
                    if (defaultSize.returns) {
                        freeReturn = defaultSize.returns.is_free;
                    }

                    return (
                        <ComparisonOption
                            key={linkId}
                            allSizesSorted={allSizesSorted}
                            buyOptionSizes={buyOption.sizes}
                            shouldDisplaySizes={shouldDisplaySizes}
                            className={style.priceBox}
                            formattedPrice={defaultSize.formatted_price}
                            freeReturn={freeReturn}
                            isAlternativeOption={index > 0}
                            isInStock={buyOption.in_stock}
                            leadUrl={defaultSize.lead_url}
                            onSale={defaultSize.is_on_sale}
                            productId={buyOption.product_id}
                            retailerName={buyOption.retailer_name}
                            salePrice={defaultSize.formatted_sale_price}
                            shippingOptions={shippingOptions}
                        />
                    );
                })}
            </Overlay>
        </React.Fragment>
    );
}

ProductDescriptionComparePrice.propTypes = {
    allSizesSorted: PropTypes.array,
    analyticsTitle: PropTypes.string,
    buyOptions: PropTypes.objectOf(BuyOptionPropType).isRequired,
    shouldDisplaySizes: PropTypes.bool,
    sortedBuyOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
    inlineVariant: PropTypes.bool,
    title: PropTypes.string,
};

export default ProductDescriptionComparePrice;
